import React from 'react';
import {
  SylController,
  SylApi,
} from '@syl-editor/core-utilities';
import ColorSelect from './ColorSelect';

/* eslint-disable max-len */
const Icon = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    height="20"
    viewBox="0 0 24 24"
    width="20"
  >
    <path fill="none" d="M0 0h24v24H0z" />
    <path d="M16.56 8.94L7.62 0 6.21 1.41l2.38 2.38-5.15 5.15c-.59.59-.59 1.54 0 2.12l5.5 5.5c.29.29.68.44 1.06.44s.77-.15 1.06-.44l5.5-5.5c.59-.58.59-1.53 0-2.12zM5.21 10L10 5.21 14.79 10H5.21zM19 11.5s-2 2.17-2 3.5c0 1.1.9 2 2 2s2-.9 2-2c0-1.33-2-3.5-2-3.5z" />
    <path color-line="true" d="M0 20h24v4H0z" />
  </svg>
);

export default class BackgroundController extends SylController<any> {
  public name = 'background';

  public toolbar = {
    className: 'diyBackground',
    // tooltip: 'diyBackground', // tip内容
    // eslint-disable-next-line react/display-name
    icon: (editor: SylApi, attrs: any) => {
      const { index, length } = editor.getSelection();
      return (
        <div
          className="diyBackground"
          ref={(ref) => {
            if (ref && ref.querySelector('svg') && attrs.color) {
              const paths = ref.querySelectorAll('path');
              ([].slice.call(paths) as SVGClipPathElement[]).forEach((path) => {
                if (path.getAttribute('color-line')) {
                  path.setAttribute('style', `fill: ${attrs.color}`);
                }
              });
            }
          }}
        >
          {Icon}
          <ColorSelect
            id="syl-diy-background-container"
            attrs={attrs}
            onClick={(color) => {
              this.editor.setFormat({
                diyBackground: {
                  color,
                },
              });
              this.editor.setSelection({ index: index + length, length: 0 });
              (document.getElementById('syl-diy-background-container') as HTMLDivElement).style.display = 'none';
            }}
          />
        </div>
      );
    }, // 按钮
    handler: () => {
      // 通过 编辑器实例.commnad.插件名.方法名 调用
      // editor.command.diyBackground.insert();
      (document.getElementById('syl-diy-background-container') as HTMLDivElement).style.display = 'flex';
    },
  };

  public defaultColor = 'rgba(0, 0, 0, 1)';

  public getAttrs = (color: { r: number; g: number; b: number; a: number }) => {
    const rgba = `rgba(${color.r}, ${color.g}, ${color.b}, ${color.a})`;
    return {
      color: rgba,
    };
  };

  public getValue = (attrs: any) => attrs.color;

  public disable = (editor: SylApi) => {
    const { $from } = editor.view.state.selection;
    if ($from.parent.type.spec.code) return true;
    return false;
  };

  // 注册插件的command
  public command = {
    insert: () => {},
  };
}
